import styled from "styled-components";
import { Switch as AntdSwitch } from "antd";

export const StyledSwitch = styled(AntdSwitch)`
  &.ant-switch {
    background-color: rgba(0, 0, 0, 0.25);
  }

  &.ant-switch-checked {
    background-color: #002244;
  }

  &.ant-switch:hover:not(.ant-switch-disabled) {
    background-color: rgba(0, 0, 0, 0.45);
  }

  &.ant-switch-checked:hover:not(.ant-switch-disabled) {
    background-color: #003366;
  }

  &.ant-switch:focus {
    box-shadow: 0 0 0 2px rgba(0, 34, 68, 0.2);
  }

  &.ant-switch-checked:focus {
    box-shadow: 0 0 0 2px rgba(0, 34, 68, 0.2);
  }
`;
